/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Button, Grid, MenuItem, Popover, Tooltip, Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
//
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnClear, BtnExportExcel, BtnSearch } from 'components/Common/Button';
import { AxiosGet, AxiosPost, AxiosPostFileExcel, ResultAPI } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import Accordion from 'components/Common/Accordion/Accordion';
import DateRangePicker from 'components/Common/ElementInForm/DateRange';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { BiEdit } from "react-icons/bi";
import { GrMail } from "react-icons/gr";
import { HiMailOpen } from "react-icons/hi";
import { FaHourglassHalf } from "react-icons/fa";
import { VscPassFilled, VscSaveAs } from "react-icons/vsc";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import moment from 'moment';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import Zoom from '@mui/material/Zoom';
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";
import { GridColumns } from '@mui/x-data-grid-pro';
import { Link, useNavigate } from 'react-router-dom';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import { FaFlagCheckered } from "react-icons/fa";
import { ImHammer2 } from "react-icons/im";
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

const MyCreateVOC_List = () => {

    const navigate = useNavigate();
    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [open, setopen] = useState(Boolean(anchorEl) || false)
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dIssueDate",
        sSortDirection: "desc"
    });

    const [Option, setOption] = useState({
        lstBA: [],
        lstVOCJobType: [],
        lstStatus: [],
    })

    //#region  Form
    let objSchema = {
        sJobCode: yupFormSchemas.string("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        arrTypeJobVOC: yupFormSchemas.stringArray("ประเภทใบงาน", { required: false }),
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด", { required: false }),
        sCompany: yupFormSchemas.string("บริษัท", { required: false }),
        sCustomer: yupFormSchemas.string("ลูกค้า", { required: false }),
        sResponPerson: yupFormSchemas.string("ผู้รับผิดชอบ", { required: false }),
        arrDateIssue: yupFormSchemas.stringArray("วันที่แจ้ง", { required: false }),
        arrDateVocOpen: yupFormSchemas.stringArray("วันที่เปิดใบงาน", { required: false }),
        arrStatus: yupFormSchemas.object("สถานะใบงาน", { required: false }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        form.setValue("arrDateIssue", [new Date(new Date().getFullYear(), new Date().getMonth(), 1), null])
        loadData(dataRow);
        GetInitialOption();
    }, [])

    const GetInitialOption = async () => {

        let oOptionVOC = {
            lstBA: [],
            lstVOCJobType: [],
            lstStatus: [],
        };

        await AxiosGet(`BAService/GetBA`, {}, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstBA: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetVOCJobType`, { "IsSuggest": true }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCJobType: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetStatus`, { "nStatusType": 2, "sLanguage": "th", "isGetDraft": true }, (res) => {

            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstStatus: res.result?.data || [] }
            })
        });
        await onSetOption(oOptionVOC);
    }

    const onSetOption = async (paramOption) => {
        setOption(paramOption)
        UnBlockUI();

    }

    const loadData = (p: PaginationInterface = dataRow) => {
        BlockUI();
        setLoadingTable(true)
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        let obj = {
            ...p,
            "sJobCode": form.getValues("sJobCode") ?? null,
            "sLanguage": currentLanguage(),
            "sVOCFormCode": form.getValues("sVOCFormCode") ?? null,
            "lstVOCJobTypeID": form.getValues("arrTypeJobVOC") ? form.getValues("arrTypeJobVOC") : null,
            "lstBAID": form.getValues("arrBA") ? form.getValues("arrBA") : null,
            "sResponsible": form.getValues("sResponPerson") ?? null,
            "sCompany": form.getValues("sCompany") ?? null,
            "sCustomer": form.getValues("sCustomer") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("YYYY-MM-DD") : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("YYYY-MM-DD") : null,
            "sOpenIssueStart": form.getValues("arrDateVocOpen")[0] ? moment(form.getValues("arrDateVocOpen")[0]).format("YYYY-MM-DD") : null,
            "sOpenIssueEnd": form.getValues("arrDateVocOpen")[1] ? moment(form.getValues("arrDateVocOpen")[1]).format("YYYY-MM-DD") : null,
            "lstStatusID": form.getValues("arrStatus") ? form.getValues("arrStatus") : null,
        }
        AxiosPost(`VOC/SearchVOCFormDataList`, obj, (res) => {
            UnBlockUI();
            setLoadingTable(false)
            ResultAPI(res, null, () => {
                setDataRow({
                    ...p,
                    arrRows: res.result.data || [],
                    nDataLength: res.result.nDataLength,
                    nPageIndex: res.result.nPageIndex,
                });
            })
        }, () => {
            setLoadingTable(false)
        })
    };

    const ExportFile = (p: PaginationInterface = dataRow) => {
        let Param = {
            ...p,
            "sJobCode": form.getValues("sJobCode") ?? null,
            "sLanguage": currentLanguage(),
            "sVOCFormCode": form.getValues("sVOCFormCode") ?? null,
            "lstVOCJobTypeID": form.getValues("arrTypeJobVOC") ? form.getValues("arrTypeJobVOC") : [],
            "lstBAID": form.getValues("arrBA") ? form.getValues("arrBA") : [],
            "sResponsible": form.getValues("sResponPerson") ?? null,
            "sCompany": form.getValues("sCompany") ?? null,
            "sCustomer": form.getValues("sCustomer") ?? null,
            "sIssueDateStart": form.getValues("arrDateIssue")[0] ? (moment(form.getValues("arrDateIssue")[0])).format("YYYY-MM-DD") : null,
            "sIssueDateEnd": form.getValues("arrDateIssue")[1] ? (moment(form.getValues("arrDateIssue")[1])).format("YYYY-MM-DD") : null,
            "sOpenIssueStart": form.getValues("arrDateVocOpen")[0] ? moment(form.getValues("arrDateVocOpen")[0]).format("YYYY-MM-DD") : null,
            "sOpenIssueEnd": form.getValues("arrDateVocOpen")[1] ? moment(form.getValues("arrDateVocOpen")[1]).format("YYYY-MM-DD") : null,
            "lstStatusID": form.getValues("arrStatus") ? form.getValues("arrStatus") : [],
            "IsExport": true,
        }
        let sFileName = `ข้อมูลใบงาน_${moment().format("DDMMYYYYHHmmss")}`;
        AxiosPostFileExcel(`Export/ExportCreateVOC`, Param, sFileName, null, null, BlockUI, UnBlockUI)
    }

    const ClearFieldSearch = () => {
        Object.keys(form.getValues()).forEach((key => {
            if (key === "arrDateIssue" || key === "arrDateVocOpen") {
                form.setValue(key, [null, null])
            }
            else {
                form.setValue(key, null);
            }
            form.clearErrors(key);
        }))
        loadData(dataRow);
    }


    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setopen(true)
        setAnchorEl(event.currentTarget);
    };

    const onHandleGotoVOCCreate = (sType: string) => {
        let sPath = "";
        switch (sType) {
            case "comp":
                sPath = "/Backend/MyCreateVOCList/PageComplaint";
                break;
            case "req":
                sPath = "/Backend/MyCreateVOCList/PageRequest";
                break;
            case "sugg":
                sPath = "/Backend/MyCreateVOCList/PageSuggest";
                break;
        }
        navigate(sPath);

    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 50,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sJobCode",
            headerName: "เลขที่ใบงาน",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let nJobTypeID = item.row?.nJobTypeID;
                let nVOCFormTypeID = item.row?.nVOCFormTypeID;
                let IsEdit = item.row?.IsEdit;
                
                if (nVOCFormTypeID == 3) {
                    return (<></>)
                }
                else {
                    return (
                        <>
                        {/* ใบที่ต้องรับผิดชอบต้องทำได้ */}
                            <Link
                                to={nVOCFormTypeID == 2 ? "/Backend/MyCreateVOCList/PageProductAndService" : nJobTypeID === 1 ? "/Backend/MyCreateVOCList/PageComplaint" : nJobTypeID === 2 ? "/Backend/MyCreateVOCList/PageRequest" : "/Backend/MyCreateVOCList/PageSuggest"}
                                state={{
                                    sVOCFormID: item.row.sVOCFormID,
                                    sJobCode: item.row.sJobCode,
                                    sMode: IsEdit ? "Edit" : "view",
                                    sFrom: IsEdit ? "" :  'myvoc'
                                }}
                                style={{ color: "#228dbd", textDecoration: "underline", cursor: "pointer" }}
                            >
                                {item.value}
                            </Link>
                        </>
                    )
                }
            },
        },
        {
            field: "sJobType",
            headerName: "ประเภทใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
        },
        {
            field: "sVOCFormCode",
            headerName: "เลขที่ใบแจ้ง",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let nJobTypeID = item.row?.nJobTypeID;
                let nVOCFormTypeID = item.row?.nVOCFormTypeID;
                let IsEdit = item.row?.IsEdit;
                return (
                    <>
                        <Link
                            to={nVOCFormTypeID == 2 ? "/Backend/MyCreateVOCList/PageProductAndService" : nJobTypeID === 1 ? "/Backend/MyCreateVOCList/PageComplaint" : nJobTypeID === 2 ? "/Backend/MyCreateVOCList/PageRequest" : "/Backend/MyCreateVOCList/PageSuggest"}
                            state={{
                                sVOCFormID: item.row.sVOCFormID,
                                sJobCode: item.row.sJobCode,
                                sMode: IsEdit ? "Edit" : "view",
                                sFrom: IsEdit ? "" :  'myvoc'
                            }}
                            style={{ color: "#228dbd", textDecoration: "underline", cursor: "pointer" }}
                        >
                            {item.value}
                        </Link>
                    </>
                );
            },
        },
        {
            field: "dIssueDate",
            headerName: "วันที่แจ้ง",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sOwnerBA",
            headerName: "กลุ่มตลาด",
            headerAlign: "center",
            flex: 1,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: true,
        },
        {
            field: "sCompanyName",
            headerName: "บริษัท",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 200,
            sortable: true,
            renderCell: (item) => {
                return (
                    <Tooltip title={item.value} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"}>{item.value} </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "sCustomerName",
            headerName: "ลูกค้า",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "sOpenIssueName",
            headerName: "ผู้เปิดใบงาน",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "sResponAction",
            headerName: "ผู้รับผิดชอบ",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
        },
        {
            field: "nStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            resizable: true,
            disableReorder: true,
            width: 80,
            sortable: false,
            renderCell: (item) => {
                if (item.value === 10) {
                    return (
                        <Tooltip title={"เปิดใหม่"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><GrMail style={{ fontSize: '1.2em', color: '#02a7f0' }} /></Typography>
                        </Tooltip>
                    );
                }
                else if (item.value === 11) {
                    return (
                        <Tooltip title={"เปิดอ่าน"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><HiMailOpen style={{ fontSize: '1.2em', color: '#02a7f0' }} /></Typography>
                        </Tooltip>
                    );
                }
                else if ([12, 17, 18].includes(item.value)) {
                    return (
                        <Tooltip title={"กำลังดำเนินการ"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><FaHourglassHalf style={{ fontSize: '1.2em', color: '#f7b660' }} /></Typography>
                        </Tooltip>
                    );
                }
                else if ([13].includes(item.value)) {
                    return (
                        <Tooltip title={"พิจารณาแนวทางการแก้ไข"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><ImHammer2 style={{ fontSize: '1.2em', color: '#f7b660' }} /></Typography>
                        </Tooltip>
                    );
                }
                else if ([14].includes(item.value)) {
                    return (
                        <Tooltip title={"จัดทำแผนการแก้ไขระยะยาว"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><FaFlagCheckered style={{ fontSize: '1.2em', color: '#f7b660' }} /></Typography>
                        </Tooltip>
                    );
                }
                else if (item.value === 15) {
                    return (
                        <Tooltip title={"แก้ไขแล้ว"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><VscPassFilled style={{ fontSize: '1.2em', color: '#66cc66' }} /></Typography>
                        </Tooltip>
                    );
                }
                else if (item.value === 16) {
                    return (
                        <Tooltip title={"ปิดแล้ว"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><MdOutlineMarkEmailRead style={{ fontSize: '1.2em', color: '#08cdc1' }} /></Typography>
                        </Tooltip>
                    );
                }
                else if (item.value === 9) {
                    return (
                        <Tooltip title={"บันทึกร่าง"} TransitionComponent={Zoom} placement="top" >
                            <Typography component={"label"}><VscSaveAs style={{ fontSize: '1.2em', color: '#000000' }} /></Typography>
                        </Tooltip>
                    );
                }
            },
        },
    ];

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<BiEdit style={{ fontSize: '1.5em' }} />}
                labal_Head="สร้างใบงาน"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                <Grid item xs={12}>
                    <FormProvider {...form}>
                        <Accordion header={"ค้นหาข้อมูล"}>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                <Grid item xs={12} sm={6} md={2}>
                                    <InputFormItem
                                        id="sJobCode"
                                        name="sJobCode"
                                        label="เลขที่ใบงาน"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={2}>
                                    <InputFormItem
                                        id="sVOCFormCode"
                                        name="sVOCFormCode"
                                        label="เลขที่ใบแจ้ง"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MultiSelectForm
                                        name="arrTypeJobVOC"
                                        options={Option.lstVOCJobType || []}
                                        label={"ประเภทใบงาน"}
                                        required={false}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MultiSelectForm
                                        name="arrBA"
                                        options={Option.lstBA || []}
                                        label={"กลุ่มตลาด"}
                                        required={false}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputFormItem
                                        id="sCompany"
                                        name="sCompany"
                                        label="บริษัท"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputFormItem
                                        id="sCustomer"
                                        name="sCustomer"
                                        label="ลูกค้า"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputFormItem
                                        id="sResponPerson"
                                        name="sResponPerson"
                                        label="ผู้รับผิดชอบ"
                                        required={false}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={4}>
                                    <DateRangePicker
                                        label="วันที่แจ้ง (เริ่มต้น)"
                                        lableEnd="วันที่แจ้ง (สิ้นสุด)"
                                        require={false}
                                        name="arrDateIssue"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={4}>
                                    <DateRangePicker
                                        label="เปิดใบงาน (เริ่มต้น)"
                                        lableEnd="เปิดใบงาน (สิ้นสุด)"
                                        require={false}
                                        name="arrDateVocOpen"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <MultiSelectForm
                                        name="arrStatus"
                                        options={Option.lstStatus || []}
                                        label={"สถานะใบงาน"}
                                        required={false}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                        <Grid item>
                                            <BtnSearch onClick={() => { loadData() }} />
                                        </Grid>
                                        <Grid item>
                                            <BtnClear onClick={() => { ClearFieldSearch() }} />
                                        </Grid>
                                        <Grid item>
                                            <BtnExportExcel onClick={() => { ExportFile() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Accordion>
                    </FormProvider>
                </Grid>
                <Grid item xs={12}>
                    <Accordion header={"ข้อมูลใบงาน"}>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                            <Grid item xs={12} >
                                <Button
                                    id="demo-customized-button"
                                    aria-controls={open ? 'demo-customized-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    variant="contained"
                                    disableElevation
                                    onClick={handleClick}
                                    startIcon={<BiEdit />}
                                    endIcon={open ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon />}
                                    style={{ backgroundColor: "#66cc66" }}
                                >
                                    สร้างใบงาน
                                </Button>
                                <Popover
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={() => { setAnchorEl(null); setopen(false); }}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    PaperProps={{
                                        style: { width: '145px !important' },
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '145px',
                                        }}
                                    >
                                        <MenuItem onClick={() => { onHandleGotoVOCCreate("comp") }} disableRipple>
                                            ข้อร้องเรียน
                                        </MenuItem>
                                        <MenuItem onClick={() => { onHandleGotoVOCCreate("req") }} disableRipple>
                                            ข้อร้องขอ
                                        </MenuItem>
                                        <MenuItem onClick={() => { onHandleGotoVOCCreate("sugg") }} disableRipple>
                                            ข้อเสนอแนะ
                                        </MenuItem>  </div>

                                </Popover>
                            </Grid>
                            <Grid item xs={12} >
                                <Table
                                    isLoading={loadingTable}
                                    OnLoadData={(p) => loadData(p)}
                                    Rows={dataRow}
                                    HiddenToolHead={true}
                                    Columns={dataColumn}
                                    backgroundHeaderCustom={"#004290"}
                                    sxCustomHeader={{ color: '#ffffff' }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <VscSaveAs style={{ fontSize: '1.2em', color: '#000000' }} />&nbsp;&nbsp;&nbsp;<span>บันทึกร่าง</span>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <GrMail style={{ fontSize: '1.2em', color: '#02a7f0' }} />&nbsp;&nbsp;&nbsp;<span>เปิดใหม่</span>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <HiMailOpen style={{ fontSize: '1.2em', color: '#02a7f0' }} />&nbsp;&nbsp;&nbsp;<span>เปิดอ่าน</span></Grid>
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <FaHourglassHalf style={{ fontSize: '1.2em', color: '#f7b660' }} />&nbsp;&nbsp;&nbsp;<span>กำลังดำเนินการ</span>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <ImHammer2 style={{ fontSize: '1.2em', color: '#f7b660' }} />&nbsp;&nbsp;&nbsp;<span>พิจารณาแนวทางการแก้ไข</span>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <FaFlagCheckered style={{ fontSize: '1.2em', color: '#f7b660' }} />&nbsp;&nbsp;&nbsp;<span>จัดทำแผนการแก้ไขระยะยาว</span>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <VscPassFilled style={{ fontSize: '1.2em', color: '#66cc66' }} />&nbsp;&nbsp;&nbsp;<span>แก้ไขแล้ว</span>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={'auto'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <MdOutlineMarkEmailRead style={{ fontSize: '1.2em', color: '#08cdc1' }} />&nbsp;&nbsp;&nbsp;<span>ปิดแล้ว</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Accordion>
                </Grid>
            </Grid>
        </>
    )
}

export default MyCreateVOC_List